import { handleize } from '@ribajs/utils'
import { charIsHex } from './number.js'

export const isColor = (colorStr: string) => {
  // E.g. "#ffffff"
  if (colorStr.startsWith('#')) {
    return true
  }

  // E.g. "fff" or "ffffff"
  if (colorStr.length <= 6 || colorStr.length >= 3) {
    let isHex = true
    for (const char of colorStr) {
      isHex = isHex && charIsHex(char)
      if (!isHex) return false
    }
    return true
  }

  return false
}

/**
 * Renders a text color class for a background color.
 * JavaScript implementation of `shopify/snippets/utils-text-color-for-background.liquid`
 * @param bgColor
 * @returns
 */
export const getTextColorForBackground = (bgColor?: string) => {
  bgColor = handleizeColor(bgColor)
  const textColorClasses: string[] = []

  if (bgColor?.startsWith('bg-')) {
    bgColor = bgColor.slice(3)
  }

  switch (bgColor) {
    case 'white':
    case 'light-orange':
    case 'light-beige':
    case 'light-baby-blue':
    case 'transparent':
      textColorClasses.push('text-current')
      break
    case 'orange':
      textColorClasses.push('text-light-lemon')
      break
    case 'deep-orange':
      textColorClasses.push('text-light-lemon')
      break
    case 'red-rose':
      textColorClasses.push('text-pale-rose')
      break
    case 'vivid-violet':
      textColorClasses.push('text-lavender')
      break
    case 'light-lemon':
      textColorClasses.push('text-deep-orange')
      break
    case 'pale-rose':
      textColorClasses.push('text-red-rose')
      break
    case 'lavender':
      textColorClasses.push('text-vivid-violet')
      break
    case 'light-azure':
      textColorClasses.push('text-electric-blue')
      break
    case 'electric-blue':
      textColorClasses.push('text-light-azure')
      break
    case 'apple-green':
      textColorClasses.push('text-celtic-green')
      break
    case 'celtic-green':
      textColorClasses.push('text-apple-green')
      break
    default:
      textColorClasses.push('text-white', 'rte-white')
      break
  }

  return textColorClasses
}

export const handleizeColor = (color?: string) => {
  if (
    color &&
    !color.startsWith('bg-') &&
    !color.startsWith('text-') &&
    !color.startsWith('rte-')
  ) {
    color = handleize(color)
  }
  return color
}
/**
 * Renders a button variant class for a background color.
 * JavaScript implementation of `shopify/snippets/utils-button-variant-for-background.liquid`
 * @param bgColor
 */
export const getButtonVariantForBackground = (bgColor?: string) => {
  bgColor = handleizeColor(bgColor)

  let buttonVariant = 'button--primary'

  switch (bgColor) {
    case 'light-orange':
      buttonVariant = 'button--primary'
      break
    case 'orange':
      buttonVariant = 'button--light-orange'
      break
    case 'light-green':
      buttonVariant = 'button--dark-green'
      break
    case 'dark-green':
      buttonVariant = 'button--light-green'
      break
    case 'dark-blue':
      buttonVariant = 'button--light-baby-blue'
      break
    case 'light-baby-blue':
    case 'melone':
    case 'blue':
      buttonVariant = 'button--dark-blue'
      break
    case 'light-beige':
    case 'red-brown':
    case 'light-brown':
      buttonVariant = 'button--secondary'
      break
    case 'deep-orange':
      buttonVariant = 'button--light-lemon'
      break
    case 'red-rose':
      buttonVariant = 'button--pale-rose'
      break
    case 'vivid-violet':
      buttonVariant = 'button--lavender'
      break
    case 'light-lemon':
      buttonVariant = 'button--deep-orange'
      break
    case 'pale-rose':
      buttonVariant = 'button--red-rose'
      break
    case 'lavender':
      buttonVariant = 'button--vivid-violet'
      break
    case 'light-azure':
      buttonVariant = 'button--electric-blue'
      break
    case 'electric-blue':
      buttonVariant = 'button--light-azure'
      break
    case 'apple-green':
      buttonVariant = 'button--celtic-green'
      break
    case 'celtic-green':
      buttonVariant = 'button--apple-green'
      break
    default:
      buttonVariant = 'button--primary'
      break
  }

  return buttonVariant
}
